import { ArrowLeft, Bell, Database, DollarSign, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RagStatsCard } from '../components/knowledge/RagStatsCard';
import { OpenAiStatsCard } from '../components/metrics/OpenAiStatsCard';
import { SpendAlertsCard } from '../components/metrics/SpendAlertsCard';

export default function Metrics() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/dashboard')}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="h-5 w-5 text-gray-600" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Métricas Completas</h1>
          <p className="text-gray-600">Monitoramento detalhado de recursos e custos</p>
        </div>
      </div>

      {/* RAG/ChromaDB Section */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Database className="h-5 w-5 text-emerald-600" />
          <h2 className="text-lg font-semibold text-gray-900">Base de Conhecimento (RAG)</h2>
        </div>
        <RagStatsCard />
      </div>

      {/* OpenAI/LLM Section */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Zap className="h-5 w-5 text-purple-600" />
          <h2 className="text-lg font-semibold text-gray-900">Uso de LLM (OpenAI)</h2>
        </div>
        <OpenAiStatsCard />
      </div>

      {/* Spend Alerts Section */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Bell className="h-5 w-5 text-amber-600" />
          <h2 className="text-lg font-semibold text-gray-900">Alertas de Gasto (OpenAI)</h2>
        </div>
        <SpendAlertsCard />
      </div>

      {/* AWS Section - Placeholder */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <DollarSign className="h-5 w-5 text-orange-600" />
          <h2 className="text-lg font-semibold text-gray-900">Custos AWS</h2>
        </div>
        <div className="bg-white shadow rounded-lg p-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
              <DollarSign className="h-8 w-8 text-orange-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Custos e Consumo AWS</h3>
            <p className="text-sm text-gray-500 mb-4">
              Integração com AWS Cost Explorer em desenvolvimento
            </p>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-600 mb-1">Custo Mensal</p>
                <p className="text-2xl font-bold text-gray-400">---</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-600 mb-1">ECS/Fargate</p>
                <p className="text-2xl font-bold text-gray-400">---</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-600 mb-1">RDS</p>
                <p className="text-2xl font-bold text-gray-400">---</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-600 mb-1">S3/Storage</p>
                <p className="text-2xl font-bold text-gray-400">---</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Info Footer */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-1.5">
        <p className="text-sm text-blue-800">
          💡 <strong>Legenda de fontes:</strong>
        </p>
        <ul className="text-xs text-blue-700 space-y-1 ml-2">
          <li>
            <span className="inline-block bg-green-100 text-green-700 px-1 py-0.5 rounded text-[10px] font-mono mr-1">live</span>
            Dado real — capturado diretamente da API da OpenAI ou do banco de dados da aplicação.
          </li>
          <li>
            <span className="inline-block bg-blue-100 text-blue-700 px-1 py-0.5 rounded text-[10px] font-mono mr-1">calc</span>
            Calculado — custo derivado dos tokens reais (prompt + completion) de cada requisição,
            multiplicado pela tabela de preços (banco de dados, <code className="font-mono">model_pricing</code>).
            Precisão tipicamente &gt;99%. A OpenAI não expõe custo por usuário ou por requisição — só custo total da org.
          </li>
          <li>
            <span className="text-blue-500">💰 Orçamento:</span> a OpenAI não expõe saldo de créditos via API —
            o valor "Disponível" é calculado como orçamento mensal (configurável) menos o custo real do mês.
          </li>
          <li>
            <span className="text-blue-500">☁️ Custos AWS:</span> integração com AWS Cost Explorer em desenvolvimento.
          </li>
        </ul>
      </div>
    </div>
  );
}
